import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * Route guard for a per-account feature (`/api/auth/me` features).
 *
 * Off → redirect Home (replace, so Back does not bounce through the dead
 * route). The shell only mounts routes once `/me` has resolved, so `features`
 * is already final here — there is no "loading" flash to guard against.
 *
 * Presentation only: the server refuses the gated calls itself.
 */
export function RequireFeature({ feature, children }) {
  const { hasFeature } = useAuth();
  if (!hasFeature(feature)) return <Navigate to="/" replace />;
  return children;
}
